// src/context/ModalContext.js
import React, { createContext, useState, useContext } from "react";

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [activeProject, setActiveProject] = useState(null);

	const openModal = (project) => {
		setActiveProject(project);
		setIsOpen(true);
		// Prevent scrolling of the background when modal is open
		document.body.style.overflow = "hidden";
	};

	const closeModal = () => {
		setIsOpen(false);
		setActiveProject(null);
		// Re-enable scrolling when modal is closed
		document.body.style.overflow = "auto";
	};

	return (
		<ModalContext.Provider
			value={{ isOpen, activeProject, openModal, closeModal }}
		>
			{children}
		</ModalContext.Provider>
	);
};
